import { OrdersPerDay, WaiterQuantities, WaiterTables } from './deal.types';

export const tables = {
  'Menos de 15': WaiterTables.LessThan15,
  [WaiterTables.LessThan15]: 'Menos de 15',

  'De 15 a 30': WaiterTables.Between15And30,
  [WaiterTables.Between15And30]: 'De 15 a 30',

  'Mais de 30': WaiterTables.MoreThan30,
  [WaiterTables.MoreThan30]: 'Mais de 30',
};

const quantity = {
  'Menos de 3': WaiterQuantities.LessThan3,
  [WaiterQuantities.LessThan3]: 'Menos de 3',

  'De 3 a 5': WaiterQuantities.Between3And5,
  [WaiterQuantities.Between3And5]: 'De 3 a 5',

  'Mais de 5': WaiterQuantities.MoreThan5,
  [WaiterQuantities.MoreThan5]: 'Mais de 5',
};

const orderPerDay = {
  'Menos de 10': OrdersPerDay.LessThan10,
  [OrdersPerDay.LessThan10]: 'Menos de 10',

  'Mais de 10': OrdersPerDay.MoreThan10,
  [OrdersPerDay.MoreThan10]: 'Mais de 10',
};

export const waiterTablesValues = (value?: string): WaiterTables | undefined => {
  return tables[value as keyof typeof tables] as WaiterTables;
};

export const waiterQuantityValues = (value?: string) => {
  return quantity[value as keyof typeof quantity] as WaiterQuantities;
};

export const ordersPerDayValues = (value?: string): OrdersPerDay | undefined => {
  return orderPerDay[value as keyof typeof orderPerDay] as OrdersPerDay;
};
